/**
 * Asset row helpers shared by the processing modal (self-custody) and the confirmation
 * modal (custodial): the name, collection, location and category of one asset, read from
 * the NFT object a flow passes as its image.
 */

/** Name, collection, location and category of one asset; empty strings where the object had no value. */
export interface ProgressAssetSummary {
    name: string;
    collection: string;
    location: string;
    category: string;
}

export function summariseProgressAsset(asset: any): ProgressAssetSummary {
    const attribute = (key: string): string => {
        const match = Array.isArray(asset?.attributes)
            ? asset.attributes.find((item: any) => item?.key?.toLowerCase() === key)
            : null;
        return typeof match?.value === 'string' ? match.value : '';
    };
    return {
        name: typeof asset?.name === 'string' ? asset.name : '',
        collection: typeof asset?.collections?.name === 'string' ? asset.collections.name : '',
        location: attribute('location'),
        category: attribute('category'),
    };
}

/** Adds the app's closing full stop to a value that does not already end in punctuation. */
export function withStop(text: string): string {
    const trimmed = (text || '').trim();
    return !trimmed || /[.!?]$/.test(trimmed) ? trimmed : `${trimmed}.`;
}
